import { isPaymentsTestMode } from "@/lib/stripe";

/**
 * Tiny banner shown when the embedded payments are running in test mode.
 * Renders nothing in live mode, so it's safe to mount unconditionally.
 */
export const PaymentTestModeBanner = () => {
  if (!isPaymentsTestMode()) return null;
  return (
    <div className="w-full border-b border-accent bg-accent/40 px-4 py-1.5 text-center text-xs text-foreground">
      Payments in this preview are in test mode. Use card{" "}
      <strong>4242 4242 4242 4242</strong> to try the upgrade.
    </div>
  );
};
